/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.17",
    versionName: "0.2.0-nightly.2025.7.17",
    versionChannel: "nightly",
    buildDate: "2025-07-17T00:07:55.476Z",
    commitHash: "526cc260aa40dd441eb596b1eb5e5601063a093a",
};
